import { SafeAreaContent } from "@/components/content/safe-area-content";
import { cn } from "@/utils/cn";
import { IonPage } from "@ionic/react";
import { memo, useState } from "react";
import { AddFoodModal } from "../add-food-modal";
import { MyPlanHeader } from "./my-plan-header";

interface MyPlanPageContainerProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  pageRef: React.RefObject<HTMLElement>;
  showHeader?: boolean;
}

export const MyPlanPageContainer = memo(function MyPlanPageContainer({
  id,
  children,
  className,
  pageRef,
  showHeader = true,
}: MyPlanPageContainerProps) {
  const [isAddFoodModalOpen, setIsAddFoodModalOpen] = useState(false);

  const handleOpenAddFoodModal = () => {
    setIsAddFoodModalOpen(true);
  };

  const handleCloseAddFoodModal = () => {
    setIsAddFoodModalOpen(false);
  };

  return (
    <IonPage id={id} ref={pageRef}>
      <SafeAreaContent fullscreen>
        <div
          className={cn(
            "flex flex-col items-start justify-start gap-4 self-center",
            "pt-[calc(var(--safe-area-inset-top)+1rem)]",
            "mx-auto h-full w-full max-w-[450px] bg-white",
            className,
          )}
        >
          {showHeader && <MyPlanHeader onAddFoodClick={handleOpenAddFoodModal} />}
          {children}
        </div>
      </SafeAreaContent>

      <AddFoodModal isOpen={isAddFoodModalOpen} onDismiss={handleCloseAddFoodModal} />
    </IonPage>
  );
});
